module.exports = __webpack_public_path__ + "img/reason_3.a1b7d74b.png";